import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getTalentTags } from "./talentTagsAPI";
import { TalentTag, GetTalentTagsRequest } from "./talentTagsAPI";

type Entities = {
  [key: string]: TalentTag;
};

export type SliceState = {
  ids: string[];
  entities: Entities;
  status: "idle" | "pending" | "succeeded" | "failed";
  error?: string;
};

const talentTagsAdapter = createEntityAdapter<TalentTag>();

export const fetchTalentTags = createAsyncThunk<
  TalentTag[],
  GetTalentTagsRequest,
  { state: RootState }
>(
  "tags/fetchTalentTags",
  async (getTalentTagsRequest: GetTalentTagsRequest, { requestId }) => {
    const res = await getTalentTags(getTalentTagsRequest, { requestId });
    return res.data;
  },
);

export const talentTagsSlice = createSlice({
  name: "tags",
  initialState: talentTagsAdapter.getInitialState({
    status: "idle",
    error: undefined,
  }) as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTalentTags.pending, (state) => {
      state.status = "pending";
    });
    builder.addCase(fetchTalentTags.fulfilled, (state, action) => {
      talentTagsAdapter.setAll(state, action.payload);
      state.status = "succeeded";
    });
    builder.addCase(fetchTalentTags.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    });
  },
});

export const { selectAll: selectAllTalentTags } =
  talentTagsAdapter.getSelectors((state: RootState) => state.talentTags);

export const talentTagsReducer = talentTagsSlice.reducer;
